<template>
<div class="chapter">
<div class="inner_page">
<a id="page_1"></a>
<p class="subtitle"><span class="bold">IMAGES OF WAR</span></p>
<h1 class="title"><span class="bold">THE MALAYAN EMERGENCY</span></h1>
<p class="subtitlea"><span class="bold">THE CRUCIAL YEARS: 1949–53</span></p>
<p class="subtitle2"><span class="bold">RARE PHOTOGRAPHS FROM WARTIME ARCHIVES</span></p>
<p class="author"><span class="bold">Mark Forsdike</span></p>
<div class="img_containerp">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Title.vue?41b604f0